module.exports = __webpack_public_path__ + "20ee3e0265a04e37d17d68feb7f98359.png";